<app-view-title Title="{{ 'Intellitrailer.MyPage.Overview.TitleMyBookings' | translate : 'My bookings' }}" [isPrimaryColor]="true"></app-view-title>
<view-content [centered]="true">
  <mat-tab-group (selectedTabChange)="onTabChange($event)" mat-stretch-tabs>
    <mat-tab label="{{ 'Intellitrailer.MyPage.Overview.ActiveBookings' | translate : 'Active bookings' }}">
      @if(!loading && futureRents.length == 0 && activeRents.length == 0)
      {
        <app-information-screen [secondaryColor]="true" (actionClick)="importBooking()"
                                image="/assets/Images/calendar_today_white.png"
                                title=" {{ 'Intellitrailer.MyPage.Overview.NoBookingsFound' | translate : 'No bookings found' }}"
                                secondaryContent="{{ 'Intellitrailer.MyPage.MyBookings.ImportExistingBooking' | translate : 'If you already have created a booking, you can' }} "
                                actionContent="{{ 'Intellitrailer.MyPage.MyBookings.ImportHere' | translate : 'import it here' }}">
        </app-information-screen>
      }
      @else {
        @if(loading){
        <div class="spinner-container">
          <mat-spinner diameter="70" mode="indeterminate" class="inverted-spinner"></mat-spinner>
        </div>
        }
        @else {
          @if(activeRents.length > 0) {
            <h2>{{ 'Intellitrailer.MyPage.Overview.ActiveBookings' | translate : 'Active bookings' }}</h2>
            <div class="row" *ngFor="let booking of activeRents">
              <app-booking-overview [booking]="booking" (navigate)="navigate($event)" (cancelled)="cancelled($event)"></app-booking-overview>
            </div>
          }
          @if(futureRents.length > 0) {
            <h2>{{ 'Intellitrailer.MyPage.Overview.FutureBookings' | translate : 'Future bookings' }}</h2>
            <div class="row" *ngFor="let booking of futureRents">
              <app-booking-overview [booking]="booking" (navigate)="navigate($event)" (cancelled)="cancelled($event)"></app-booking-overview>
            </div>
          }

         }
      }
    </mat-tab>
    <mat-tab label="{{ 'Intellitrailer.MyPage.Overview.History' | translate : 'History' }}">
      @if(!loading && canceledBookings.length == 0 && pastRents.length == 0) {
      <app-information-screen [secondaryColor]="true" (actionClick)="importBooking()"
                              image="/assets/Images/calendar_today_white.png"
                              title=" {{ 'Intellitrailer.MyPage.Overview.NoBookingsFound' | translate : 'No bookings found' }}"
                              secondaryContent="{{ 'Intellitrailer.MyPage.MyBookings.ImportExistingBooking' | translate : 'If you already have created a booking, you can' }} "
                              actionContent="{{ 'Intellitrailer.MyPage.MyBookings.ImportHere' | translate : 'import it here' }}">
      </app-information-screen>
      }
      @else {
        @if(loading){
        <div class="spinner-container">
          <mat-spinner diameter="70" mode="indeterminate" class="inverted-spinner"></mat-spinner>
        </div>
        }
        @else {
        @if(pastRents.length > 0) {
          <h2>{{ 'Intellitrailer.MyPage.Overview.CompletedRents' | translate : 'Completed rents' }}</h2>
          <div class="row" *ngFor="let booking of pastRents">
            <app-booking-overview [booking]="booking" (navigate)="navigate($event)" (cancelled)="cancelled($event)"></app-booking-overview>
          </div>
        }
        @if(canceledBookings.length > 0) {
          <h2>{{ 'Intellitrailer.MyPage.Overview.CanceledBookings' | translate : 'Canceled bookings' }}</h2>
          <div class="row" *ngFor="let booking of canceledBookings">
            <app-booking-overview [booking]="booking" (navigate)="navigate($event)" (cancelled)="cancelled($event)"></app-booking-overview>
          </div>
        }
      }
     }

    </mat-tab>
  </mat-tab-group>
</view-content>

<view-actions>
  <button mat-raised-button color="accent" (click)="refreshBookings()"><mat-icon>refresh</mat-icon>{{ 'Intellitrailer.MyPage.Dialog.Update' | translate : 'Update' }}</button>
</view-actions>


